import type { ReactNode } from 'react'
import type { UnitId } from '@/annotations'

/**
 * `div.acard.astep` → `auth-card` (process/08-COMPONENT-CATALOGUE.md). "The card every
 * authentication screen is drawn in" — every one of the 17 auth-family units carries data-scr on
 * this exact element, never on a wrapper around it (process/01-UI-CONTRACT.md §2 rule 1).
 *
 * Prototype_v2.html .acard: max-width 420px (layout — 11-TOKEN-MAP.md's out-of-scope width),
 * background #fff → --panel, border 1px solid var(--bd) (border-width is not a token family),
 * border-radius 6px → --r-3 (0 delta), padding 30px 34px 32px → --sp-11 (+2px) / 34px (not a
 * token, layout) / --sp-11 (+0px), box-shadow → --shadow-1.
 */
export function AuthCard({ unitId, children }: { unitId: UnitId; children: ReactNode }) {
  return (
    <div
      data-cmp="auth-card"
      data-scr={unitId}
      className="mx-auto max-w-[420px] bg-panel border border-bd rounded-3 pt-11 px-[34px] pb-11 shadow-1"
    >
      {children}
    </div>
  )
}
